import { hasTreatment } from '@/lib/features/utils';

// Experiments related to specific features

export const shouldShowOTP = (): boolean => {
  return hasTreatment('FEATURE_ONBOARDING_OTP');
};
